import { Component, Input, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import {  MatPaginator,  MatDialog,  MatTableDataSource,  MatSnackBar} from '@angular/material';
import { PontuacaoResultadoVo } from './pontuacao-resultado.vo';
import { PontuacaoService } from '../pontuacao/pontuacao.service';
import { PontuacaoResultadoDialogComponent } from './pontuacao-resultado-dialog.component';

@Component({
  templateUrl: './pontuacao-resultado-list.component.html',
  selector: 'pontuacao-resultado-list',
  styleUrls: ['./pontuacao-resultado-list.component.css']
})
export class PontuacaoResultadoListComponent implements OnInit, AfterViewInit {
  @Input()  lista: PontuacaoResultadoVo[];
  @Input()  carregaMatriculaAutomatica= true;
  @ViewChild(MatPaginator)  paginator: MatPaginator;
  public resultado: PontuacaoResultadoVo;
  public mensagemTela: string;

  public columnsToDisplay = ['periodo', 'situacao', 'acao'];

  public dataSource = new MatTableDataSource<PontuacaoResultadoVo>(this.lista);
  public pageSize = 10;
  public offset: number;

  public isLoading: boolean;

  // construtor
  constructor(
    private pontuacaoService: PontuacaoService,
    public mensagem: MatSnackBar,
    public dialog: MatDialog
  ) {}

  // ngOnInit é executado ao entrar na tela
  ngOnInit() {
    if (this.lista) {
      this.dataSource = new MatTableDataSource<PontuacaoResultadoVo>(this.lista);
      this.dataSource.paginator = this.paginator;
      this.formataCabecalho(this.lista);
    } else {
      if(this.carregaMatriculaAutomatica) {
        this.carregaMatricula();
      }
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  carregaMatricula() {
    const storage = JSON.parse(localStorage.getItem('sae'));
    this.buscar(storage['user']);
  }

  // busca com filtro
  buscar(matricula: string) {
    this.mensagemTela = null;
    this.lista = null;
    
    this.isLoading = true;
    this.pontuacaoService.pontuacaoResultado(matricula).subscribe(
      (result: PontuacaoResultadoVo[]) => {
        this.lista = result;
        this.formataCabecalho(this.lista);
        this.dataSource = new MatTableDataSource<PontuacaoResultadoVo>(result);
        this.dataSource.paginator = this.paginator;
        this.isLoading = false;
      },
      (error: string) => {
        this.mensagemTela = error;
        this.isLoading = false;
      }
    );
  }

  formataCabecalho(lista: PontuacaoResultadoVo[]) {
    let ehGrupo1 = false;
    if (lista) {
      lista.forEach(result => {
        if (result.grupo === 1) {
          ehGrupo1 = true;
        }
        // pego qql resulato. pois são iguais, soh muda o grupo.
        this.resultado = result;
      });

      if (this.resultado) {
        if (ehGrupo1) {
          this.resultado.grupo = 1;
        } else {
          this.resultado.grupo = 2;
        }
      }
    }
  }

  verPontuacao(pontuacaoResultadoVo: PontuacaoResultadoVo) {
    if (pontuacaoResultadoVo.pontuacao) {
      let dialogRef = this.dialog.open(PontuacaoResultadoDialogComponent, {
        width: '1680px',
        height: '900px',
        data: pontuacaoResultadoVo.pontuacao
      });
      let resultado: any;
      dialogRef.afterClosed().subscribe(result => {});
    }
  }

  // mostra erros na tela
  erro(erro: string) {
    this.mensagem.open(erro, 'X', { duration: 5000 });
    this.isLoading = false;
  }

  // finaliza o subscribe
  finaliza() {
    this.isLoading = false;
  }
}
